module.exports = __webpack_public_path__ + "static/7-02a91f949995d44267cde85d742bc341.png";